export default class ModulesConfig {
  static GetModules() {
    return [
      {
        moduleName: "HealthCare",
        requiredRole: "HealthCare-access",
        base: "$VUE_APP_HEALTHCARE_BASE",
        libraries: ["app.HealthCare.js", "app.HealthCare.css"],
        priority: 1,
        isIgnored: "$VUE_APP_HEALTHCARE_IGNORE",
      },
      {
        moduleName: "DmPortal",
        requiredRole: "DmPortal-access",
        base: "$VUE_APP_DM_BASE",
        libraries: ["app.dmPortal.js", "app.dmPortal.css"],
        priority: 1,
        isIgnored: "$VUE_APP_DEVICEMANAGER_IGNORE",
      },
      {
        moduleName: "AmrRadio",
        requiredRole: "AmrRadio-access",
        base: "$VUE_APP_RADIO_BASE",
        libraries: ["app.AmrRadio.js", "app.AmrRadio.css"],
        priority: 2,
        isIgnored: "$VUE_APP_RADIO_IGNORE",
      },
      {
        moduleName: "AmrBusiness",
        requiredRole: "AmrBusiness-access",
        base: "$VUE_APP_BUSINESS_BASE",
        libraries: ["app.AmrBusiness.js", "app.AmrBusiness.css"],
        priority: 3,
        isIgnored: "$VUE_APP_BUSINESS_IGNORE",
      },
      // A react app example:
      // {
      //   moduleName: "Optirevenu",
      //   requiredRole: "DmPortal-access", // TODO: replace with the actual optirevenu access role
      //   base: "https://localhost:7065/static/",
      //   libraries: ["main.f170f472.js", "main.e6c13ad2.css"],
      //   priority: 4,
      //   isIgnored: "false",
      //   isReact: true,
      // },
    ];
  }
}
